export const selectWidths = {
  s: 200,
  m: 260,
  l: 520,
  fullWidth: '100%',
};
